import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation as MuiBottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Home, Favorite, ViewList, Message, Person, MonetizationOn, ShoppingBag, Divider } from '@mui/icons-material';
import { useI18n } from '../context/I18nContext';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();
  const [value, setValue] = React.useState(getActiveTab(location.pathname));

  // Get active tab based on current path
  function getActiveTab(path) {
    if (path === '/') return 'home';
    if (path.startsWith('/favorites')) return 'favorites';
    if (path.startsWith('/ads')) return 'ads';
    if (path.startsWith('/create-ad')) return 'ads';
    if (path.startsWith('/edit-ad')) return 'ads';
    if (path.startsWith('/messages')) return 'messages';
    if (path.startsWith('/profile')) return 'profile';
    return 'home';
  }

  // Update active tab when location changes
  React.useEffect(() => {
    setValue(getActiveTab(location.pathname));
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 'home':
        navigate('/');
        break;
      case 'favorites':
        navigate('/favorites');
        break;
      case 'ads':
        navigate('/ads');
        break;
      case 'messages':
        navigate('/messages');
        break;
      case 'profile':
        navigate('/profile');
        break;
      default:
        navigate('/');
    }
  };

  return (
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
      <MuiBottomNavigation
        showLabels
        value={value}
        onChange={handleChange}
        sx={{
          paddingLeft: '1px',
          paddingRight: '1px',
          '& .MuiBottomNavigationAction-root': {
            color: 'text.secondary',
            position: 'relative',
            minWidth: 0,
            padding: '3px 6px',
            flex: 1,
            '&:first-of-type': {
              marginLeft: '2px',
            },
            '&:last-of-type': {
              marginRight: '2px',
            },
            '&:not(:last-child)::after': {
              content: '""',
              position: 'absolute',
              right: 0,
              top: '25%',
              height: '75%',
              width: '1px',
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
              opacity: 0.5,
            },
          },
          '& .Mui-selected': {
            color: 'primary.main',
          },
        }}
      >
        <BottomNavigationAction label={t('home.title', 'Home')} value="home" icon={<Home />} />
        <BottomNavigationAction label={t('favorites.title', 'Favorites')} value="favorites" icon={<Favorite />} />
        <BottomNavigationAction label={t('myAds.title', 'My Ads')} value="ads" icon={<ShoppingBag />} />
        <BottomNavigationAction label={t('messages.title', 'Messages')} value="messages" icon={<Message />} />
        <BottomNavigationAction label={t('profile.title', 'Profile')} value="profile" icon={<Person />} />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation;
